import React from 'react';

/**
 * Skeleton loading card component
 * Displays a placeholder while movie cards are loading
 */
const SkeletonCard = () => {
  return (
    <div className="relative bg-gray-800 rounded-lg overflow-hidden animate-pulse">
      {/* Poster skeleton */}
      <div className="w-full aspect-[2/3] bg-gray-700">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-700 via-gray-600 to-gray-700 animate-shimmer" />
      </div>

      {/* Content skeleton */}
      <div className="p-4 space-y-3">
        {/* Title skeleton */}
        <div className="h-5 bg-gray-700 rounded w-3/4" />

        {/* Rating skeleton */}
        <div className="flex items-center space-x-2">
          <div className="h-4 w-4 bg-gray-700 rounded" />
          <div className="h-4 bg-gray-700 rounded w-12" />
        </div>

        {/* Button skeleton */}
        <div className="h-9 bg-gray-700 rounded" />
      </div>
    </div>
  );
};

export default SkeletonCard;
